import Carousel from 'global/carousel.src';
import startFreeTrialForm from 'global/free-trial-form-multiple.src';

((fn) => {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    /**
     * Carousel
     */
    [].forEach.call(document.querySelectorAll('.carousel'), (item) => {
        const c = new Carousel(item);
    });

    [].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
        startFreeTrialForm.init(form);
    });
});
